if ($("header#header").length) {
  loadFooter(customHeader);

  function customHeader() {
    $("#customerLogin").append($("#footer .registrationBanner").clone());
    $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");

    $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");

    document.addEventListener("ShoptetDOMSearchResultsLoaded", function () {
      if ($(".search-whisperer.active .search-whisperer-empty").length) {
        if (!$(".search-whisperer.active .search-whisperer-empty .notFound").length) {
          $(".search-whisperer.active  .search-whisperer-empty").append($("#footer .notFound").clone());

          $('<span class="close"></span>').appendTo(".search-whisperer .notFound");

          $(".search-whisperer .contactWrap").append("<div class='contacts'></div>");
          $(".search-whisperer .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
          $(".search-whisperer span.tel").append(`<span class="info">${telefonInfo}</span>`);
          $(".search-whisperer .contacts").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
          $(".search-whisperer span.mail").append(`<span class="info">${mailInfo}</span>`);
        }
      }

      $(".notFound span.close").on("click", function () {
        $(".search-whisperer").removeClass("active");
        $('.search input[type="search"]').val("").trigger("input").trigger("change");
      });
    });
  }
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    checkCartState();
    checkHeight();
  });
  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    checkCartState();
    checkHeight();
  });
  $(document).ready(function () {
    checkCartState();
    cartWidgetNaturalImages();
  });
  document.addEventListener("ShoptetDOMPageContentLoaded", cartWidgetNaturalImages);
  document.addEventListener("ShoptetCartUpdated", function () {
    checkCartState();
    checkHeight();
    cartWidgetNaturalImages();
  });
  // miniatura 100x100 z Shoptetu je natažená / s okraji, originál má přirozený poměr stran
  function cartWidgetNaturalImages() {
    $(".cart-widget-product-image img, .id--9 .cart-table .cart-p-image img").each(function () {
      ["src", "data-src"].forEach((attr) => {
        const value = this.getAttribute(attr) || "";
        if (value.indexOf("/related/") === -1) return;
        this.setAttribute(attr, value.split("?")[0].replace("/related/", "/orig/"));
      });
      this.removeAttribute("width");
      this.removeAttribute("height");
    });
  }
  if (typeof MutationObserver === "function") {
    const cartImagesObserver = new MutationObserver(cartWidgetNaturalImages);
    ["#cart-widget", ".id--9 #content"].forEach(function (selector) {
      const el = document.querySelector(selector);
      if (el) cartImagesObserver.observe(el, { childList: true, subtree: true });
    });
  }

  $("#navigation").append($(".top-navigation-bar .top-navigation-bar-menu").clone());
  $("#navigation").append("<div class='contacts'></div>");
  $("#navigation .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $("#navigation span.tel").append(`<span class="info">${telefonInfo}</span>`);
  $("#navigation .contacts").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  $("#navigation span.mail").append(`<span class="info">${mailInfo}</span>`);

  $("header#header").css("margin-bottom", "0");

  $(function () {
    $("#header").append($("#footer .usps").clone());
  });

  $('body.mobile a[data-target="cart"]').removeClass("toggle-window");
  if (!$("#cart-widget .emptyCart").length) {
    $("#cart-widget").append($("#footer .emptyCart").clone());
  }
  if (!$("#cart-widget .cartCategories").length) {
    $("#cart-widget").append($("#footer .cartCategories").clone());
  }

  $(".search-input").attr("placeholder", "Co hledáte...např. povlečení");

  $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
  $(".header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());

  $('.navigation-buttons a[data-target="cart"]').clone().removeAttr("data-hover").appendTo(".header-top .responsive-tools");
  $(".top-navigation-tools").append('<a href="/registrace">Registrovat se</a>');

  $(".header-top").append("<div class='contacts'></div>");
  $(".header-top .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $(".header-top span.tel").append(`<span class="info">${telefonInfo}</span>`);
  $(".header-top .contacts").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  $(".header-top span.mail").append(`<span class="info">${mailInfo}</span>`);

  $(".header-top .responsive-tools").append($(".header-top .site-name-wrapper").clone());

  $(document).ready(function () {
    const $cartHoverArea = $(".responsive-tools a[data-target='cart'], .responsive-tools .cart-count");
    const $cartWidget = $("#cart-widget");
    let cartCloseTimeout = null;

    function clearCartCloseTimeout() {
      if (cartCloseTimeout) {
        clearTimeout(cartCloseTimeout);
        cartCloseTimeout = null;
      }
    }

    function openCartWidget() {
      clearCartCloseTimeout();
      shoptet.popups.showPopupWindow("cart", true);
      $("body").addClass("cart-window-visible");
      $cartWidget.css("display", "block");
    }

    function closeCartWidget() {
      clearCartCloseTimeout();
      if ($(".responsive-tools a[data-target='cart']:hover").length || $(".responsive-tools .cart-count:hover").length || $cartWidget.is(":hover")) {
        return;
      }

      if (shoptet?.popups && typeof shoptet.popups.hidePopupWindow === "function") {
        shoptet.popups.hidePopupWindow("cart");
      }
      $("body").removeClass("cart-window-visible");
      $cartWidget.css("display", "none");
    }

    $cartHoverArea.off("mouseenter.cartHover mouseleave.cartHover");
    $cartHoverArea.on("mouseenter.cartHover", function () {
      if (window.matchMedia("(min-width: 992px)").matches) {
        openCartWidget();
      }
    });

    $cartHoverArea.on("mouseleave.cartHover", function () {
      if (window.matchMedia("(min-width: 992px)").matches) {
        clearCartCloseTimeout();
        cartCloseTimeout = setTimeout(closeCartWidget, 60);
      }
    });

    $cartWidget.off("mouseenter.cartHover mouseleave.cartHover");
    $cartWidget.on("mouseenter.cartHover", function () {
      if (window.matchMedia("(min-width: 992px)").matches) {
        clearCartCloseTimeout();
      }
    });

    $cartWidget.on("mouseleave.cartHover", function () {
      if (window.matchMedia("(min-width: 992px)").matches) {
        closeCartWidget();
      }
    });
  });
}
